import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: true,
};

const userDetailSidebarSlice = createSlice({
  name: 'userDetailSidebar',
  initialState,
  reducers: {
    openUserDetailSidebar: (state) => {
      state.isOpen = true;
    },
    closeUserDetailSidebar: (state) => {
      state.isOpen = false;
    },
    toggleUserDetailSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const {
  openUserDetailSidebar,
  closeUserDetailSidebar,
  toggleUserDetailSidebar,
} = userDetailSidebarSlice.actions;

export const selectIsUserDetailSidebarOpen = (state) => state.userDetailSidebar.isOpen;

export default userDetailSidebarSlice.reducer; 